export const usePageHeadMetaData = () => {
  const envConfig = useRuntimeConfig().public
  const route = useRoute()

  const setDefaultMeta = () => {
    const title = RESOURCE.SERVICE_NAME
    const description = RESOURCE.META.DESCRIPTION
    const host = envConfig.home
    const requestUrl = `${host}${route.fullPath}`
    // todo 추후 이미지 추가
    const ogImage = ''

    useSeoMeta({
      applicationName: title,
      title,
      description,
      keywords: RESOURCE.META.IDUS_KEYWORD.toString(),
      ogTitle: title,
      ogType: 'website',
      ogDescription: description,
      ogUrl: requestUrl,
      ogLocale: RESOURCE.META.LOCALE,
      ogSiteName: title,
      ogImage,
    })
  }

  const setDefaultHead = () => {
    useHead({
      title: `${RESOURCE.SERVICE_NAME}`,
      link: [
        {
          rel: 'canonical',
          href: `${envConfig.home}${route.path}`,
        },
      ],
    })
  }

  return {
    setDefaultMeta,
    setDefaultHead,
  }
}
